module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('SwiperList', {
    attrs: {
      "swiperList": _vm.swiperList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-inner",
    staticStyle: {
      "padding": "0px 10px 20px 10px"
    }
  }, [_c('div', {
    staticClass: "b-d-b c-hui",
    staticStyle: {
      "font-size": "14px",
      "padding-right": "2px",
      "padding-bottom": "2px",
      "margin-bottom": "10px"
    },
    attrs: {
      "flex": "main:right"
    }
  }, [_c('span', {
    on: {
      "click": _vm.backList
    }
  }, [_vm._v("返回列表页"), _c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("》")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-flg"
  }, [_c('div', {
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "font-weight": "900",
      "padding-bottom": "20px"
    }
  }, [_vm._v(_vm._s(_vm.model.operwcontitle))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow()),
      expression: "isShow()"
    }],
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-right": "4px"
    }
  }, [_vm._v("日期: " + _vm._s(_vm._f("shortDate")(_vm.model.createtime)))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("阅读数: " + _vm._s(_vm.model.click == 0 ? 1 : +_vm.model.click + 1))])]), _vm._v(" "), _c('div', {
    staticClass: "operwconcontents",
    domProps: {
      "innerHTML": _vm._s(_vm.model.operwconcontents)
    }
  }), _vm._v(" "), (_vm.model.appends) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [(_vm.model.appends.length > 0) ? _c('div', [_vm._v("附件信息：")]) : _vm._e(), _vm._v(" "), (_vm.model.appends.length > 0) ? _c('div', _vm._l((_vm.model.appends), function(i) {
    return _c('div', {
      key: i.id
    }, [_c('div', {
      staticStyle: {
        "color": "#2f74ff",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.downFile(i.appendurl)
        }
      }
    }, [_vm._v(_vm._s(i.appendfilename))])])
  }), 0) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "a-c c-hui",
    staticStyle: {
      "font-size": "14px",
      "padding-top": "50px"
    }
  }, [_c('div', {
    staticClass: "b-d-b",
    staticStyle: {
      "width": "150px",
      "margin": "auto",
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "p-h",
    staticStyle: {
      "position": "absolute",
      "left": "40px",
      "top": "-10px",
      "background": "#fff"
    },
    on: {
      "click": _vm.backList
    }
  }, [_vm._v("返回列表页")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-6df172e7!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/web/OperWconDetail.vue
// module id = 300
// module chunks = 0